<template>
  <div class="view-container">
    <div class="search-panel">
      <div class="search-row">
        <div class="search-item">
          <label><i class="fas fa-id-badge"></i> 公司ID:</label>
          <input v-model="searchCode" type="text" placeholder="请输入公司ID" class="search-input">
        </div>
        <div class="search-item">
          <label><i class="fas fa-building"></i> 公司名称:</label>
          <input v-model="searchName" type="text" placeholder="请输入公司名称" class="search-input">
        </div>
        <div class="search-item">
          <label><i class="fas fa-toggle-on"></i> 状态:</label>
          <select v-model="searchStatus" class="search-input" style="width:100px">
            <option value="">全部</option>
            <option value="启用">启用</option>
            <option value="禁用">禁用</option>
          </select>
        </div>
        <div class="search-actions">
          <button @click="handleSearch" class="btn btn-primary search-btn"><i class="fas fa-search"></i> 查询</button>
          <button @click="resetSearch" class="btn btn-default search-btn"><i class="fas fa-undo"></i> 重置</button>
        </div>
      </div>
    </div>

    <div class="stats-row">
      <div class="stat-card"><div class="stat-value">{{ tenants.length }}</div><div class="stat-label">总账套数</div></div>
      <div class="stat-card"><div class="stat-value" style="color:#16a34a">{{ tenants.filter(c => c.status === '启用').length }}</div><div class="stat-label">启用账套</div></div>
      <div class="stat-card"><div class="stat-value" style="color:#dc2626">{{ tenants.filter(c => c.status === '禁用').length }}</div><div class="stat-label">禁用账套</div></div>
    </div>

    <div class="table-wrapper">
      <div class="table-header-row">
        <button class="btn btn-primary btn-sm" @click="handleAdd"><i class="fas fa-plus"></i> 新增账套</button>
      </div>
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th width="60">序号</th>
              <th width="100">公司ID</th>
              <th width="200">公司名称</th>
              <th width="100">联系人</th>
              <th width="120">联系电话</th>
              <th width="160">联系邮件</th>
              <th width="80">状态</th>
              <th width="120">创建时间</th>
              <th class="action-column" width="100">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, idx) in paginatedTenants" :key="t.guid">
              <td>{{ (currentPage - 1) * pageSize + idx + 1 }}</td>
              <td><code>{{ t.tenantID }}</code></td>
              <td>{{ t.corpName }}</td>
              <td>{{ t.corpContact || '-' }}</td>
              <td>{{ t.corpPhone || '-' }}</td>
              <td>{{ t.corpMail || '-' }}</td>
              <td><span class="status-badge" :class="t.status === '启用' ? 'enabled' : 'disabled'">{{ t.status }}</span></td>
              <td>{{ t.createTime }}</td>
              <td class="action-column">
                <button @click="handleEdit(t)" class="btn btn-primary btn-xs" title="编辑"><i class="fas fa-edit"></i></button>
                <button @click="handleToggleStatus(t)" class="btn btn-warning btn-xs" title="切换状态"><i class="fas" :class="t.status === '启用' ? 'fa-ban' : 'fa-check'"></i></button>
                <button @click="handleDelete(t)" class="btn btn-danger btn-xs" title="删除"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
            <tr v-if="paginatedTenants.length === 0"><td colspan="9" class="empty-cell">暂无账套数据</td></tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-row">
        <div class="pagination-info">共 {{ totalTenants }} 条记录</div>
        <div class="pagination-controls">
          <div class="page-size-selector"><span>每页</span><select v-model="pageSize" class="page-size-input form-control"><option :value="20">20</option><option :value="50">50</option><option :value="75">75</option><option :value="100">100</option></select><span>条</span></div>
          <button @click="prevPage" :disabled="currentPage===1" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-left"></i></button>
          <div class="page-numbers"><button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="['page-btn',{active:currentPage===page,disabled:page==='...'}]" :disabled="page==='...'">{{ page }}</button></div>
          <button @click="nextPage" :disabled="currentPage>=totalPages" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-right"></i></button>
          <div class="page-jump"><span>跳转到</span><input type="number" v-model="jumpPage" min="1" :max="totalPages" class="jump-input" @keyup.enter="handleJump"><span>页</span><button @click="handleJump" class="btn btn-primary btn-sm jump-btn">GO</button></div>
        </div>
      </div>
    </div>

    <!-- 编辑/新增弹窗 -->
    <div v-if="showEditModal" class="modal-overlay" @click.self="closeEditModal">
      <div class="modal-container modal-md">
        <div class="modal-header">
          <h3>{{ editingGuid ? '编辑账套' : '新增账套' }}</h3>
          <button @click="closeEditModal" class="close-btn"><i class="fas fa-times"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group" style="flex:1">
              <label>公司ID <span style="color:red">*</span></label>
              <input v-model="editForm.tenantID" type="text" class="form-control" :disabled="!!editingGuid" placeholder="如: G001">
              <span v-if="editingGuid" style="color:#999;font-size:11px">公司ID不可修改</span>
            </div>
            <div class="form-group" style="flex:1">
              <label>公司名称 <span style="color:red">*</span></label>
              <input v-model="editForm.corpName" type="text" class="form-control" placeholder="公司名称">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group" style="flex:1">
              <label>联系人</label>
              <input v-model="editForm.corpContact" type="text" class="form-control" placeholder="联系人">
            </div>
            <div class="form-group" style="flex:1">
              <label>联系电话</label>
              <input v-model="editForm.corpPhone" type="text" class="form-control" placeholder="联系电话">
            </div>
          </div>
          <div class="form-group">
            <label>联系邮件</label>
            <input v-model="editForm.corpMail" type="text" class="form-control" placeholder="联系邮箱">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="editForm.active" style="margin-right:6px">
              启用
            </label>
          </div>
          <div v-if="!editingGuid" class="create-tip">
            <i class="fas fa-info-circle"></i> 新建账套将自动创建数据库 <code>GoodDB_{{ editForm.tenantID || '???' }}</code>，并执行 NewCloudDB.sql 初始化数据结构。
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeEditModal" class="btn btn-default">取消</button>
          <button @click="saveEdit" class="btn btn-primary" :disabled="saving">
            <i v-if="saving" class="fas fa-spinner fa-spin"></i>
            {{ saving ? '保存中...' : '保存' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { getAllTenants, createTenant, updateTenant, deleteTenant, toggleTenantStatus } from '../api/tenant'

const searchCode = ref('')
const searchName = ref('')
const searchStatus = ref('')
const currentPage = ref(1)
const pageSize = ref(20)
const jumpPage = ref(1)
const showEditModal = ref(false)
const editingGuid = ref(null)
const saving = ref(false)

const tenants = ref([])
const editForm = reactive({
  tenantID: '',
  corpName: '',
  corpContact: '',
  corpPhone: '',
  corpMail: '',
  active: true
})

const fmt = (v) => {
  if (v === undefined || v === null) return ''
  return String(v).replace('T', ' ').substring(0, 10)
}

const loadTenants = async () => {
  try {
    const res = await getAllTenants()
    const list = res.Data || res.data || []
    tenants.value = list.map(t => ({
      guid: t.guid || t.Guid || '',
      tenantID: t.tenantID || t.TenantID || '',
      corpName: t.corpName || t.CorpName || '',
      corpContact: t.corpContact || t.CorpContact || '',
      corpPhone: t.corpPhone || t.CorpPhone || '',
      corpMail: t.corpMail || t.CorpMail || '',
      status: t.active === '启用' ? '启用' : (t.Active === 1 || t.active === 1 ? '启用' : '禁用'),
      createTime: fmt(t.createTime || t.CreateTime)
    }))
  } catch (e) {
    console.error('加载账套失败', e)
  }
}

onMounted(loadTenants)

const filteredTenants = computed(() => {
  let result = [...tenants.value]
  if (searchCode.value) result = result.filter(t => t.tenantID.includes(searchCode.value))
  if (searchName.value) result = result.filter(t => t.corpName.includes(searchName.value))
  if (searchStatus.value) result = result.filter(t => t.status === searchStatus.value)
  return result
})

const totalTenants = computed(() => filteredTenants.value.length)
const totalPages = computed(() => Math.ceil(totalTenants.value / pageSize.value) || 1)
const paginatedTenants = computed(() => {
  const s = (currentPage.value - 1) * pageSize.value
  return filteredTenants.value.slice(s, s + pageSize.value)
})

const visiblePages = computed(() => {
  const pages = [], total = totalPages.value, current = currentPage.value
  if (total <= 7) { for (let i = 1; i <= total; i++) pages.push(i) }
  else { pages.push(1); if (current > 4) pages.push('...'); for (let i = Math.max(2, current - 2); i <= Math.min(total - 1, current + 2); i++) pages.push(i); if (current < total - 3) pages.push('...'); pages.push(total) }
  return pages
})

const handleSearch = () => { currentPage.value = 1 }
const resetSearch = () => { searchCode.value = ''; searchName.value = ''; searchStatus.value = ''; currentPage.value = 1 }
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (p) => { if (typeof p === 'number' && p >= 1 && p <= totalPages.value) currentPage.value = p }
const handleJump = () => { const p = parseInt(jumpPage.value); p >= 1 && p <= totalPages.value ? currentPage.value = p : jumpPage.value = currentPage.value }

// 新增
const handleAdd = () => {
  editingGuid.value = null
  editForm.tenantID = ''
  editForm.corpName = ''
  editForm.corpContact = ''
  editForm.corpPhone = ''
  editForm.corpMail = ''
  editForm.active = true
  showEditModal.value = true
}

// 编辑
const handleEdit = (row) => {
  editingGuid.value = row.guid
  editForm.tenantID = row.tenantID
  editForm.corpName = row.corpName
  editForm.corpContact = row.corpContact
  editForm.corpPhone = row.corpPhone
  editForm.corpMail = row.corpMail
  editForm.active = row.status === '启用'
  showEditModal.value = true
}

const closeEditModal = () => { showEditModal.value = false; editingGuid.value = null }

const saveEdit = async () => {
  if (!editForm.tenantID.trim()) return $message.warning('请输入公司ID')
  if (!editForm.corpName.trim()) return $message.warning('请输入公司名称')

  saving.value = true
  try {
    const data = {
      tenantID: editForm.tenantID.trim(),
      corpName: editForm.corpName.trim(),
      corpContact: editForm.corpContact.trim(),
      corpPhone: editForm.corpPhone.trim(),
      corpMail: editForm.corpMail.trim(),
      active: editForm.active
    }

    if (editingGuid.value) {
      await updateTenant(editingGuid.value, data)
      $message.success('编辑成功')
    } else {
      const res = await createTenant(data)
      $message.success(res.Msg || res.msg || '新建账套成功')
    }
    closeEditModal()
    await loadTenants()
  } catch (e) {
    console.error('保存失败', e)
    const msg = e?.response?.data?.Msg || e?.response?.data?.msg || e?.message || '未知错误'
    $message.error('保存失败: ' + msg)
  } finally {
    saving.value = false
  }
}

// 删除
const handleDelete = async (row) => {
  if (!await $confirm(`确定删除账套 "${row.corpName}" (${row.tenantID}) 吗？此操作不可恢复。`)) return
  try {
    await deleteTenant(row.guid)
    $message.success('删除成功')
    await loadTenants()
  } catch (e) {
    const msg = e?.response?.data?.Msg || e?.response?.data?.msg || e?.message || '未知错误'
    $message.error('删除失败: ' + msg)
  }
}

// 切换状态
const handleToggleStatus = async (row) => {
  try {
    await toggleTenantStatus(row.guid)
    await loadTenants()
  } catch (e) {
    const msg = e?.response?.data?.Msg || e?.response?.data?.msg || e?.message || '未知错误'
    $message.error('切换状态失败: ' + msg)
  }
}
</script>

<style scoped>
.view-container { padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); display: flex; flex-direction: column; max-height: calc(100vh - 150px); overflow: hidden; }

.btn { padding: 6px 15px; border-radius: 4px; border: none; cursor: pointer; font-size: 13px; display: inline-flex; align-items: center; gap: 5px; transition: all 0.2s ease; }
.btn:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-primary { background-color: #1ab394; color: #fff; }
.btn-primary:hover:not(:disabled) { background-color: #18a689; }
.btn-default { background-color: #f3f3f4; color: #676a6c; border: 1px solid #e7eaec; }
.btn-default:hover:not(:disabled) { background-color: #e7eaec; }
.btn-danger { background-color: #d9534f; color: #fff; }
.btn-danger:hover:not(:disabled) { background-color: #c9302c; }
.btn-warning { background-color: #f0ad4e; color: #fff; }
.btn-warning:hover:not(:disabled) { background-color: #ec971f; }
.btn-xs { padding: 3px 8px; font-size: 12px; margin-right: 3px; }
.btn-sm { padding: 5px 12px; font-size: 12px; }

.search-panel { background: #fff; border: 1px solid #e0e4e8; border-radius: 8px; padding: 20px; margin-bottom: 15px; flex-shrink: 0; box-shadow: 0 1px 4px rgba(0,0,0,0.04); }
.search-row { display: flex; flex-wrap: wrap; gap: 16px; align-items: flex-end; }
.search-item { display: flex; align-items: center; gap: 8px; white-space: nowrap; }
.search-item label { font-size: 13px; color: #6b7280; font-weight: 500; }
.search-item label i { margin-right: 2px; color: #1ab394; font-size: 12px; }
.search-input { padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; width: 160px; outline: none; transition: border-color 0.2s, box-shadow 0.2s; background: #fafbfc; }
.search-input:focus { border-color: #1ab394; box-shadow: 0 0 0 3px rgba(26,179,148,0.12); background: #fff; }
.search-actions { display: flex; gap: 10px; margin-left: auto; align-self: flex-end; }
.search-btn { padding: 8px 18px; font-size: 13px; border-radius: 6px; font-weight: 500; }

.stats-row { display: flex; gap: 16px; margin-bottom: 15px; }
.stat-card { flex: 1; background: #f9f9f9; border: 1px solid #e7eaec; border-radius: 6px; padding: 16px; text-align: center; }
.stat-value { font-size: 28px; font-weight: 700; color: #1ab394; }
.stat-label { font-size: 12px; color: #676a6c; margin-top: 4px; }

.table-wrapper { border: 1px solid #e7eaec; border-radius: 4px; overflow: hidden; display: flex; flex-direction: column; flex: 1; min-height: 0; }
.table-header-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; background-color: #f9f9f9; border-bottom: 1px solid #e7eaec; flex-shrink: 0; }
.table-container { overflow-y: auto; flex: 1; min-height: 0; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 10px 15px; text-align: left; border-bottom: 1px solid #e7eaec; white-space: nowrap; font-size: 13px; color: #676a6c; }
.data-table th { background-color: #f5f5f5; font-weight: 600; position: sticky; top: 0; z-index: 2; }
.data-table tbody tr:hover { background: #f9fafb; }
code { background: #f0f0f0; padding: 2px 6px; border-radius: 3px; font-size: 12px; color: #e74c3c; }

.status-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 12px; font-weight: 500; }
.status-badge.enabled { background: #dcfce7; color: #16a34a; }
.status-badge.disabled { background: #fee2e2; color: #dc2626; }

.action-column { white-space: nowrap; }

.empty-cell { text-align: center; padding: 40px; color: #999; }

.pagination-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 15px; background-color: #f9f9f9; border-top: 1px solid #e7eaec; flex-shrink: 0; }
.pagination-info { font-size: 13px; color: #676a6c; }
.pagination-controls { display: flex; align-items: center; gap: 10px; }
.page-numbers { display: flex; gap: 5px; }
.page-btn { width: 32px; height: 32px; border: 1px solid #e7eaec; background-color: #fff; color: #676a6c; border-radius: 4px; cursor: pointer; font-size: 13px; display: flex; align-items: center; justify-content: center; transition: all 0.2s ease; }
.page-btn:hover:not(.disabled) { background-color: #f9f9f9; border-color: #1ab394; color: #1ab394; }
.page-btn.active { background-color: #1ab394; border-color: #1ab394; color: #fff; }
.page-btn.disabled { cursor: not-allowed; opacity: 0.5; }
.pagination-btn { width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center; }
.page-size-selector { display: flex; align-items: center; gap: 5px; margin-right: 10px; padding-right: 10px; border-right: 1px solid #e7eaec; font-size: 13px; }
.page-size-input { width: 60px; padding: 5px 8px; font-size: 13px; }
.page-jump { display: flex; align-items: center; gap: 5px; margin-left: 10px; padding-left: 10px; border-left: 1px solid #e7eaec; }
.page-jump span { font-size: 13px; color: #676a6c; }
.jump-input { width: 50px; padding: 5px 8px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; text-align: center; }
.jump-input:focus { outline: none; border-color: #1ab394; box-shadow: 0 0 0 2px rgba(26,179,148,0.2); }
.jump-btn { padding: 5px 12px; }

/* 弹窗 */
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-container { background: #fff; border-radius: 8px; box-shadow: 0 8px 30px rgba(0,0,0,0.18); display: flex; flex-direction: column; max-height: 85vh; }
.modal-container.modal-md { width: 560px; max-width: 90vw; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 16px 20px; border-bottom: 1px solid #e7eaec; flex-shrink: 0; }
.modal-header h3 { margin: 0; font-size: 16px; color: #3a4a63; }
.close-btn { background: none; border: none; font-size: 18px; color: #999; cursor: pointer; padding: 4px 8px; border-radius: 4px; }
.close-btn:hover { background: #f0f0f0; color: #333; }
.modal-body { padding: 20px; overflow-y: auto; flex: 1; }
.modal-footer { padding: 12px 20px; border-top: 1px solid #e7eaec; display: flex; justify-content: flex-end; gap: 10px; flex-shrink: 0; }

/* 表单 */
.form-group { margin-bottom: 14px; }
.form-group label { display: block; margin-bottom: 4px; font-size: 13px; font-weight: 500; color: #676a6c; }
.form-row { display: flex; gap: 14px; }
.form-control { width: 100%; padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; box-sizing: border-box; }
.form-control:focus { outline: none; border-color: #1ab394; box-shadow: 0 0 0 2px rgba(26,179,148,0.12); }
.form-control:disabled { background: #f5f5f5; color: #999; }

.create-tip { margin-top: 10px; padding: 10px 14px; background: #e8f5f3; border-left: 3px solid #1ab394; border-radius: 4px; font-size: 12px; color: #1a7a64; line-height: 1.6; }
.create-tip i { margin-right: 4px; }
.create-tip code { background: #d4efe9; color: #0d5e4a; }

.fa-spinner { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
</style>
